// DonutChart.js
import React from 'react'
import {Doughnut} from 'react-chartjs-2'
import {Chart as ChartJS, ArcElement, Tooltip, Legend} from 'chart.js'
import { useSelector } from 'react-redux'
import { useGetDeliveryByRegionQuery} from '../../redux/network/CustomerDashboardApi'
import { toAbsoluteUrl } from '../../../_metronic/helpers'

// Register necessary Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend)

const DonutChart = ({currency}:any) => {
  const {startDate, endDate, isFiltered} = useSelector((state: any) => state.Filter.Filter)
  const { data : deliveryByRegionData, error : rowError,} = useGetDeliveryByRegionQuery(
      { startDate, endDate },
      {
        refetchOnMountOrArgChange: true,
        pollingInterval: isFiltered ? 0 : 10000,
        skip: false,
      }
    );
  const data = {
    labels: deliveryByRegionData?.labels ?? [],
    datasets: [
      {
        label: 'Delivery by Region',
        data: deliveryByRegionData?.data ?? [],
        backgroundColor: [
          'rgba(236, 111, 102, 1)',
          'rgba(33, 147, 176, 1)',
          'rgba(97, 67, 133, 1)',
          'rgba(24, 90, 157, 1)',
          'rgba(67, 206, 162, 1)',

          'rgba(255, 159, 64, 1)', // Orange
          'rgba(255, 99, 132, 1)', // Pink
          'rgba(54, 162, 235, 1)', // Sky Blue
          'rgba(153, 102, 255, 1)', // Lavender
          'rgba(255, 205, 86, 1)', // Yellow
        ],
        hoverOffset: 4,
      },
    ],
  }
  const total = data.datasets[0].data.reduce((acc: number, value: any) => acc + Number(value), 0);

  // Options for the donut chart (e.g., cutout percentage to make it a donut)
  const options: any = {
    indexAxis: 'x' as const,
    responsive: true,
    maintainAspectRatio: false,

    plugins: {
      legend: {
        position: 'left',
        labels: {
          usePointStyle: true,
          pointStyle: 'circle',
          boxWidth: 10,
          padding: 15,
        },
      },
      tooltip: {
        enabled: true,
        callbacks: {
          label: function (tooltipItem: any) {
            const dataset = tooltipItem.dataset.data;
            const value = dataset[tooltipItem.dataIndex];
            const percentage = ((value / total) * 100).toFixed(2);
            return `${value} (${percentage}%)`;
          },
        },
      },
      title: {
        display: true,
        text: 'Names of Regions',
      },
      datalabels: {
        display: false, // Disable datalabels for this chart
      },
    },
  }

  const hasValidData =
    data.datasets[0].data &&
    data.datasets[0].data.length > 0 &&
    data.datasets[0].data.some((value: number) => value > 0)

  return (
    <div
      className='card mb-xl-8 w-100 card-xl-stretch'
      style={{
        border: '1px solid rgba(236, 111, 102, 0.1)',
      }}
    >
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold text-dark fs-2'>Delivery By Region</span>
          <span className='text-muted mt-1 fw-semibold fs-6'>Delivery Summary</span>
        </h3>
      </div>

      <div>
        {hasValidData ? (
          <div className='card-body pt-0 d-flex align-items-end' style={{height: '400px'}}>
            <Doughnut data={data} options={options} />
          </div>
        ) : (
          <div
            className='card-body pt-0 d-flex flex-column align-items-center justify-content-center'
            style={{height: '400px'}}
          >
            <img
              src={toAbsoluteUrl('/media/other/nodata.png')}
              alt="No data available"
              style={{ width: 'auto', height: '70%', objectFit: 'contain', opacity: 0.7 }}
            />
            <span className='text-muted fs-4'>No data for the selected option</span>
          </div>
        )}
      </div>
    </div>
  )
}

export default DonutChart
